import {MODALITY} from '@views/_config/FrequencyModalities';

export const FREQUENCY_IDS = {
  [MODALITY.MONTHLY]: 'SubscriptionMonthly',
  [MODALITY.BIMONTHLY]: 'SubscriptionBimonthly',
  [MODALITY.QUARTERLY]: 'SubscriptionQuarterly',
  [MODALITY.ON_DEMAND]: 'SubscriptionOndemand',
};
